import React from 'react';

const steps = [
  {
    icon: '✍️',
    number: '01',
    title: 'Describe Your Design',
    description: 'Type anything — "a dragon made of galaxies", "minimalist zen garden", or "80s retro neon vibes".',
  },
  {
    icon: '🤖',
    number: '02',
    title: 'AI Generates It',
    description: 'Our AI creates a unique, high-resolution design from your words in seconds.',
  },
  {
    icon: '👕',
    number: '03',
    title: 'Preview on Products',
    description: 'See your design live on a phone case or t-shirt. Rotate, zoom, inspect every detail.',
  },
  {
    icon: '🚀',
    number: '04',
    title: 'Order & Ship',
    description: 'One click to publish and order. Printed and shipped to your door worldwide.',
  },
];

function HowItWorks() {
  return (
    <section className="how-it-works" id="how-it-works">
      <h2 className="section-title">How It Works</h2>
      <p className="section-subtitle">From idea to product in under 60 seconds.</p>
      <div className="steps-grid">
        {steps.map((step) => (
          <div key={step.number} className="step-card">
            <div className="step-number">{step.number}</div>
            <div className="step-icon">{step.icon}</div>
            <h3 className="step-title">{step.title}</h3>
            <p className="step-desc">{step.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default HowItWorks;
